import React, { useState } from "react";
import {
  Text,
  Image,
  withSitecoreContext,
  Link,
  isEditorActive,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { RelatedLinksModel } from "./models/RelatedLinks.model";
import { RelatedLinksProps } from "./types/RelatedLinks.types";
import LazySection from "../../react-only-components/LazySection";
import { anchorWithId } from "../../helpers/anchorWithId.helper";
import { LinkField } from "../../types/types";

const RelatedLinks = (props: RelatedLinksProps) => {
  const isEE = props.sitecoreContext?.pageEditing;
  const model = new RelatedLinksModel(props);
  const RelatedLinksList = props?.fields?.["Related Links"];
  const [isContinue, setContinue] = useState(true);

  return (
    <LazySection>
      {props?.fields && (
        <div className="related-page-wrapper" id={props?.rendering?.uid}>
          <div className="related-page-content">
            <Text
              tag="h3"
              field={props?.fields?.["Related Links Title"]}
              className="related-page-title"
            />
            <Text
              tag="p"
              field={props?.fields?.["Related Links Description"]}
              className="related-page-description"
            />
          </div>
          <nav aria-label="relatedLinks" className="related-links">
            <ul className="related-pages">
              {RelatedLinksList?.map((item, i) => {
                return i <= 3 ? (
                  <li className={"related-pages-list"} key={i}>
                    {isEditorActive() ? (
                      <>
                        <div className="image-wrapper">
                          <Image
                            field={item.fields?.["Link Icon"]}
                            class="link-type"
                            loading="lazy"
                          />{" "}
                        </div>
                        <Link
                          field={item.fields?.Link as LinkField}
                          className="related-pages-link"
                        />
                      </>
                    ) : (
                      <a
                        href={anchorWithId(
                          item.fields?.Link?.value?.href ?? '',
                          item.fields?.Link?.value?.anchor
                        )}
                        className="related-pages-link"
                        target={item.fields?.Link?.value?.target}
                      >
                        <div className="image-wrapper">
                          <Image
                            field={item.fields?.["Link Icon"]}
                            class="link-type"
                            loading="lazy"
                          />{" "}
                        </div>
                        {item.fields?.Link?.value?.text ? (
                          <span className="link-text">
                            {item.fields.Link.value?.text}
                          </span>
                        ) : (
                          <span className="link-text">
                            {item.fields?.Link?.value?.title}
                          </span>
                        )}
                      </a>
                    )}
                  </li>
                ) : null;
              })}
            </ul>
          </nav>
        </div>
      )}
    </LazySection>
  );
};

export default withSitecoreContext()(RelatedLinks);
